import { render, staticRenderFns } from "./documentlist.vue?vue&type=template&id=137b6634&"
import script from "./documentlist.vue?vue&type=script&lang=js&"
export * from "./documentlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports